import { defer } from 'rxjs';
import http from '../network/http';

export function sendCodForm(payload) {
  // Observable<AxiosResponse<any>>
  return defer(() =>
    http.post(`	https://webhook.site/bdc3d3c8-5514-4f60-9ef3-5bffc6ec9120`, payload)
  );
}
